/* eslint-disable @typescript-eslint/no-explicit-any */
import { usePayAnInvoiceFormData } from "@/store/payAnInvoiceFormsStore";

import StepperServices from "./StepperServices";
import FormRequestPayAnInvoiceStep1 from "./FormRequestPayAnInvoiceStep1";
import FormRequestPayAnInvoiceStep2 from "./FormRequestPayAnInvoiceStep2";
import FormRequestPayAnInvoiceStep3 from "./FormRequestPayAnInvoiceStep3";
import FormRequestPayAnInvoiceStep4 from "./FormRequestPayAnInvoiceStep4";
import ContentLayout from "../layouts/ContentLayout";
import AppText from "../other/AppText";
import { useEffect } from "react";
import { toast } from "sonner";
import { CrossIcon, StatusIcon } from "@/assets/Icons";

const FormRequestPayAnInvoice = ({
  formModel: { formTabs, STEPS_TAB_LABELS },
}: {
  formModel: { formTabs: any; STEPS_TAB_LABELS: string[] };
}) => {
  console.log(formTabs, "formTabs");
  const { step } = usePayAnInvoiceFormData();
  const { partialPaymentSuccess, portalAccountCreation } = usePayAnInvoiceFormData();
  useEffect(() => {
    const value = document.getElementById("textBanner");

    if (step == 4) {
      if (value) {
        value.style.display = "none";
      }
      if (portalAccountCreation) {
        toast.custom(
          () => (
            <div className="flex flex-row bg-white p-2 border-[1px] rounded-lg border-[#E4E4E4] gap-1">
              <div className=" flex px-1.5 ">
                <StatusIcon />
              </div>
              <div className="flex flex-col">
                <AppText type="BODY_MEDIUM" className="font-[600]">
                  {formTabs?.[3]?.groups[1]?.subHeading}
                </AppText>
                <AppText type="BODY_MEDIUM">{formTabs?.[3]?.groups[0]?.description}</AppText>
              </div>
              <div
                className=" flex"
                onClick={() => {
                  toast.dismiss();
                }}
              >
                <CrossIcon />
              </div>
            </div>
          ),
          { duration: 5000 }
        );
      }
    } else {
      if (value) {
        value.style.display = "block";
      }
    }
  }, [formTabs, portalAccountCreation, step]);
  return (
    <>
      {step == 4 && (
        <ContentLayout bgColorClass="bg-royal-blue" innerClass="flex flex-col items-center gap-4">
          <AppText type="HEADLINE_LARGE" className="text-center text-white">
            {formTabs?.[3]?.groups[0]?.heading}
          </AppText>
          <AppText type="SUB_HEADING_SMALL" className="text-white text-center max-w-[736px]">
            {formTabs?.[3]?.groups[0]?.subHeading}
          </AppText>
          {partialPaymentSuccess && (
            <AppText
              type="SUB_HEADING_SMALL"
              className="text-center max-w-[736px] font-sairaSemiCondensed font-[500] text-[20px] text-[#F8DD75]"
            >
              {formTabs?.[3]?.groups[0]?.subDescription}
            </AppText>
          )}
        </ContentLayout>
      )}

      <div className="bg-black-5 relative flex justify-center w-full">
        <div className="absolute h-[120px] bg-royal-blue w-full z-1 "></div>
        <div
          className={`
                      w-full mx-auto xl:max-w-screen-2xl lg:max-w-screen-xl sm:max-w-screen-md md:max-w-screen-lg
                      px-4 lg:px-8 xl:px-[150px] 2xl:px-[104px] pb-20 z-20
                      grid-cols-4 lg:grid-cols-12 grid gap-y-2 sm:gap-y-6 xl:gap-y-[40px]
                      `}
        >
          <div className="lg:col-span-12 lg:col-start-1 lg:px-[91px] col-span-4 bg-white px-6 border-b border-b-1 border-b-[#CDD2D5]">
            <StepperServices className="bg-white" steps={STEPS_TAB_LABELS} currentStepIndex={step} />

            {step === 1 ? (
              <FormRequestPayAnInvoiceStep1 formData={formTabs[0]} />
            ) : step === 2 ? (
              <FormRequestPayAnInvoiceStep2
                formData={formTabs[1].groups[0].rows}
                label={formTabs[1].tabLabel}
                formTab={formTabs[1]}
              />
            ) : step === 3 ? (
              <FormRequestPayAnInvoiceStep3 formDataTab={formTabs[2]} />
            ) : step === 4 ? (
              <FormRequestPayAnInvoiceStep4 formDataTab={formTabs[3]} />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default FormRequestPayAnInvoice;
